import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { GroupsStoreEffects } from './groups-store.effects';
import { groupsStoreFeatureKey, reducer } from './groups-store.reducers';

export function provideGroupsStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(groupsStoreFeatureKey, reducer),
    provideEffects([GroupsStoreEffects]),
  ]);
}
